// Utility to extract property id from props or URL
// Supports `?propertyId=...`, `?property=...`, `?id=...` and naked `?<id>`
export default function getPropertyId(props = {}) {
  if (props && props.propertyId) return props.propertyId;

  const raw = (props && props.location && props.location.search) || (typeof window !== "undefined" && window.location && window.location.search) || "";
  if (!raw) return null;

  const params = new URLSearchParams(raw);
  const id = params.get("propertyId") || params.get("property") || params.get("id");
  if (id) return id;

  const s = raw.trim();
  return s.startsWith("?") && !s.includes("=") ? s.substring(1) : null;
}
